import React from "react"

import Layout from "../../components/layout"
import SEO from "../../components/seo"

// import BgParallax from "../../components/parts/BgParallax"
// import BgImg from "../../images/parallax/girl-flower.jpg"

const pourQui = () => {
  return (
    <Layout>
      <SEO title="Pour qui ?" />
      <div className="container pt-5 pb-3">
        <div className="row">
          <div className="col-md-12 mb-4">
            <h2>Pour qui&nbsp;?</h2>
          </div>
        </div>
      </div>
      {/* <BgParallax
        gradient="linear-gradient(0deg, rgba(255, 255, 255, 0.8), rgba(255, 255, 255, 0.9)) 0% 0%"
        image={`url(${BgImg})`}
      >
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <p className="text-center font-weight-bold mb-0">
                Dans le cadre de la prévention des risques psycho-sociaux et
                pour soutenir tous les projets de l’entreprise, la sophrologie
                propose une démarche pédagogique accessible et efficace à tous
                les niveaux de l’entreprise, en accompagnement individuel ou
                collectif.
              </p>
            </div>
          </div>
        </div>
      </BgParallax> */}
      <div className="container pb-5">
        <div className="row">
          <div className="col-md-12">
            <p>
              La sophrologie peut se pratiquer à tout âge de la vie. Elle
              s’adresse à tout public, à partir de 5 ans et sans limite d’âge.
              Il n’y a pas de réelle contre-indication à la pratique de la
              sophrologie. Chacun peut pratiquer dans le respect de ses limites
              et de ses capacités.
            </p>
          </div>
        </div>
      </div>
    </Layout>
  )
}

export default pourQui
